import React from 'react';

/** Edit proof-points and block heading here. */
export const VALUES_BLOCK_COPY = {
  blockTitle: 'How we work'
};

export const ENGINEER_VALUES = [
  {
    label: 'OWNERSHIP',
    headline: 'Whole problems, not ticket queues',
    body: 'You own features end-to-end, from understanding why something exists to its uptime in production.'
  },
  {
    label: 'DOMAINS',
    headline: 'Real industry constraints',
    body: 'HIPAA-grade healthcare. KYC-compliant fintech. National-scale exams. The constraints sharpen the engineering.'
  },
  {
    label: 'STACK',
    headline: 'Polyglot by deliberate choice',
    body: 'Go for fintech rails. Java for healthcare ERPs. .NET for assessment platforms. Grow across more than one.'
  }
];

/**
 * @param {{ className?: string }} props
 */
export default function ValuesList({ className = '' }) {
  return (
    <section className={`cep-block cep-values ${className}`.trim()} aria-labelledby="cep-values-heading">
      <h2 id="cep-values-heading" className="cep-block__title">
        {VALUES_BLOCK_COPY.blockTitle}
      </h2>
      <ol className="cep-values__list">
        {ENGINEER_VALUES.map((item, i) => (
          <li key={item.label} className="cep-values__item">
            <p className="cep-eyebrow cep-eyebrow--compact">
              <span className="cep-eyebrow__rule" aria-hidden="true" />
              {String(i + 1).padStart(2, '0')} · {item.label}
            </p>
            <h3 className="cep-values__headline">{item.headline}</h3>
            <p className="cep-values__body">{item.body}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}
